import axios from 'axios'
import {CONFIG} from '@/config/config.js'

export default {
  state: {
    data: {
      pf_files: {},
      doc_info: {},
      doc_viewer: null
    }
  },
  mutations: {
    updateDocInfo (state, doc_info) {
      state.data.doc_info = {...state.data.doc_info, ...doc_info}
    },
    updateCtpsImages (state, ctps_img) {
      state.data.ctps_img = ctps_img
    },
    updateCtpsContrImages (state, ctps_contrs_imgs) {
      state.data.ctps_contrs_imgs = ctps_contrs_imgs
    },
    updatePfFiles (state, pf_files) {
      state.data.pf_files = pf_files
    },
    setDocViewer(state, doc_viewer_instance){
      state.data.doc_viewer = doc_viewer_instance
    }
  },
  actions: {
    loadDocsInfo: async (context, data) => {
      await axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/document/${data.pf_id}/${data.params}/`)
      .then(response => {
        context.dispatch('loadDocsInfoRecad', data)
        context.commit('updateDocInfo', response.data.data.SocialAPI)
      }).catch(error => {
        // TODO: handle AccountUserDomain error here
      })
    },
    loadDocsInfoRecad: async (context, data) => {
      await axios.get(`${CONFIG.URL_RECAD_API_V2}/v1/servidor/document/${data.pf_id}/all/`)
      .then(response => {
        context.commit('updateDocInfo', response.data.data.RecadAPI)
      }).catch(error => {
        // TODO: handle AccountUserDomain error here
      })
    },
    loadCtpsImages: async (context, data) => {
      await axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/ctps/doc/${data.pf_id}/${data.ctps_id}/`)
      .then(response => {
        context.commit('updateCtpsImages', response.data.data.SocialAPI.files)
      }).catch(error => {
        context.commit('updateCtpsImages', [])
      })
    },
    loadCtpsContrImages: async (context, data) => {
      await axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/ctps/contratos/doc/${data.pf_id}/${data.ctps_id}/`)
      .then(response => {
        context.commit('updateCtpsContrImages', response.data.data.SocialAPI.files)
      }).catch(error => {
        context.commit('updateCtpsContrImages', [])
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/docs.js